import serviceInjectMixin from '@/mixins/serviceInject';
export default class Service {
    constructor() {
        this.subscriptions = new Set();
        this.services = new Set();
    }

    static injectMixin = serviceInjectMixin;

    destroy() {
        this.services.forEach(function(service) {
            if (service && service.destroy) {
                service.destroy();
            }
        });
        this.subscriptions.forEach(function(subscription) {
            subscription.unsubscribe();
        });
    }
}
